<template>
  <div class="about">
    <template v-if="!isMobile">
      <BarPC ref="barpc" />
      <Development @prepared="handleDataPrepared" />
      <Culture />
      <Honor />
    </template>
    <template v-else>
      <Bar ref="bar"  @tab-change="handleTabChange"  />
    <swiper 
      ref="aboutSwiper" 
      :options="swiperOptions" 
      class="about-swiper"
    >
      <swiper-slide>
        <Development @prepared="handleDataPrepared" />
      </swiper-slide>
      <swiper-slide>
        <Culture/>
      </swiper-slide>
      <swiper-slide>
        <Honor @prepared="handleDataPrepared" />
      </swiper-slide>
    </swiper>
    
    </template>
  </div>
</template>

<script>
import Development from './components/Development';
import Culture from './components/Culture';
import Honor from './components/Honor';
import Bar from './components/Bar';
import BarPC from './components/BarPC';
import { isMobile } from '@/utils/utils';
import { SUBNAV } from '@/config/about';
export default {
  name: 'About',
  components: {
    Bar,
    Development,
    Culture,
    Honor,
    BarPC
  },
  data() {
    return {
      isMobile: isMobile(),
      swiperOptions: {
        autoHeight: true,
        slidesPerView: 'auto', // 根据内容自动调整宽度
        on: {
          slideChange: () => {
            this.handleSlideChange();
          }
        }
      },
      // 防止循环触发的标志
      isTabChanging: false
    }
  },
  computed: {
    swiper() {
      return this.$refs.aboutSwiper ? this.$refs.aboutSwiper.swiper : null;
    }
  },
  mounted() {
    // 初始化时根据路由参数设置正确的页面
    this.initFromRoute();
  },
  watch: {
    /**
     * 监听路由变化
     */
    '$route'() {
      this.initFromRoute();
    }
  },
  methods: {
    /**
     * 根据路由参数初始化页面状态
     */
    initFromRoute() {
      if (!this.isMobile) return;
      
      const query = this.$route.query;
      const id = query.id;
      
      if (id) {
        // 根据id找到对应的索引
        const index = this.getIndexById(id);
        if (index !== -1) {
          // 设置标志，防止循环触发
          this.isTabChanging = true;
          
          // 更新tab状态
          if (this.$refs.bar) {
            this.$refs.bar.updateCurrentTab(index);
          }
          
          // 更新swiper页面
          this.$nextTick(() => {
            this.jumpToSwiperSlide(id);
          });
          
          // 延迟重置标志
          setTimeout(() => {
            this.isTabChanging = false;
          }, 350);
        }
      }
    },

    /**
     * 根据id获取对应的索引
     * @param {string} id 路由参数中的id
     * @returns {number} 对应的索引，-1表示未找到
     */
    getIndexById(id) {
      return SUBNAV.findIndex(item => item.id === id);
    },

    /**
     * 根据索引获取对应的id
     * @param {number} index tab索引
     * @returns {string} 对应的id
     */
    getIdByIndex(index) {
      return SUBNAV[index]?.id || SUBNAV[0]?.id || '';
    },

    /**
     * 处理数据准备完成事件
     * 在数据加载完成后重新初始化相关组件状态
     */
    handleDataPrepared() {
      // PC端处理：更新锚点位置和激活状态
      this.$refs.barpc?.updateAnchorPositions?.();
      this.$refs.barpc?.updateActiveAnchor?.();

      const query = this.$route.query;
      if (query.id) {
        this.$refs.barpc?.toAnchor?.(query.id);
      }

      // 移动端处理：重新初始化swiper实例
      if (this.isMobile && this.swiper) {
        // 重新初始化swiper实例
        this.swiper.update();
        
        // 如果当前有路由参数，跳转到对应页面
        if (query.id) {
          this.jumpToSwiperSlide(query.id);
        }
      }
    },

    /**
     * 跳转到指定的swiper页面
     * @param {string} id 页面标识
     */
    jumpToSwiperSlide(id) {
      if (!this.swiper) return;
      
      const index = this.getIndexById(id);
      if (index >= 0 && index < this.swiper.slides.length) {
        this.swiper.slideTo(index);
      }
    },

    /**
     * 处理tab切换事件
     * @param {number} index tab索引
     */
    handleTabChange(index) {
      // 设置标志，防止循环触发
      this.isTabChanging = true;
      
      // 获取对应的id并跳转到对应页面
      const id = this.getIdByIndex(index);
      this.jumpToSwiperSlide(id);
      
      // 更新路由参数
      this.updateRoute(id);
      
      // 延迟重置标志
      setTimeout(() => {
        this.isTabChanging = false;
      }, 350); // 略大于swiper的切换时间
    },

    /**
     * 更新路由参数
     * @param {string} id 要设置的路由参数id
     */
    updateRoute(id) {
      const currentQuery = { ...this.$route.query };
      currentQuery.id = id;
      
      // 使用replace避免在历史记录中创建新条目
      this.$router.replace({
        query: currentQuery
      });
    },

    /**
     * 处理swiper滑动切换事件
     */
    handleSlideChange() {
      // 获取swiper实例
      if (!this.swiper) {
        return;
      }
      
      // 如果是由tab触发的切换，则不处理
      if (this.isTabChanging) {
        return;
      }
      
      // 获取当前slide的索引
      const currentIndex = this.swiper.activeIndex;
      
      // 更新tab状态
      if (this.$refs.bar) {
        this.$refs.bar.updateCurrentTab(currentIndex);
      }
      
      // 更新路由参数
      const id = this.getIdByIndex(currentIndex);
      this.updateRoute(id);
    }
  }
};
</script>

<style lang="scss" scoped>
@import '@/styles/variables.scss';
@import '@/styles/function.scss';
.about {
  padding-top: 180px;
}

.S {
  .about{
    padding-top: rem(210)
  }
}

</style>
